import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { mockUser } from '../../mock/data';

const Layout = ({ children, userRole = 'landlord' }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  useEffect(() => {
    if (userRole === 'tenant') {
      // Check for authenticated tenant
      const tenantToken = localStorage.getItem('tenant_token') || sessionStorage.getItem('tenant_token');
      const tenantId = localStorage.getItem('tenant_id') || sessionStorage.getItem('tenant_id');
      
      if (tenantToken && tenantId) {
        // Use stored tenant information or fetch from API
        const storedTenantData = localStorage.getItem('tenant_data') || sessionStorage.getItem('tenant_data');
        if (storedTenantData) {
          setCurrentUser(JSON.parse(storedTenantData));
        } else {
          // Fallback to basic user info
          setCurrentUser({
            name: `Tenant ${tenantId.substring(0, 8)}`,
            email: 'tenant@cozykeys.com',
            role: 'Tenant'
          });
        }
      }
    } else {
      setCurrentUser(mockUser);
    }
  }, [userRole]);

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        >
          <div className="fixed inset-0 bg-black opacity-50"></div>
        </div>
      )}
      
      {/* Sidebar */}
      <div className={`
        fixed lg:static lg:inset-y-0 lg:flex lg:w-64 lg:flex-col z-50
        ${sidebarOpen ? 'inset-y-0 left-0' : '-left-64'}
        transition-all duration-300 ease-in-out lg:transition-none
      `}>
        <Sidebar userRole={userRole} onClose={() => setSidebarOpen(false)} />
      </div>
      
      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden lg:ml-0">
        <Header 
          user={currentUser} 
          onSearch={setSearchQuery} 
          onMenuClick={() => setSidebarOpen(!sidebarOpen)}
          userRole={userRole}
        />
        <main className="flex-1 overflow-auto">
          <div className="p-4 sm:p-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;